import React, { useState, useEffect, useRef } from "react";
import './Home.css';

import Feed from "./Feed/Feed";
import Cards from "./Cards/Cards";
import LogoClouds from "./LogoClouds/LogoClouds";
import CarouselComercial from './Carousel/CarouselComercial'
import CarouselHome from './Carousel/CarouselHome'

export default function Home({ imageTime }) {
  const [imageVisible, setImageVisible] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const imageContainerRef = useRef(null);

  const detectIos = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setIsIos(true);
    }
  };

  useEffect(() => {
    detectIos();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            entry.target.classList.add('blur-none');
            entry.target.classList.add('evening');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.8 }
    );

    if (imageContainerRef.current) {
      observer.observe(imageContainerRef.current);
    }

    return () => {
      if (imageContainerRef.current) {
        observer.unobserve(imageContainerRef.current);
      }
    };
  }, []);

  return (
    <div className="w-full">
      {/* Home Image */}
      <div className="flex flex-col lg:flex-row w-full lg:h-[89dvh] xl:h-[89dvh] 2xl:h-[90dvh] ">
      {/* Image Container - Adjust to take full width on smaller screens */}
      <div
        id="image-container"
        ref={imageContainerRef}
        className={`flex flex-col justify-between transition-all duration-1000 transform ${
          imageVisible ? "animate" : ""
        } ${imageTime} ${isIos ? "no-blur ios-animate" : ""}
          ${isIos ? "evening" : ""}
        lg:flex-[8]`}
        style={{ flexShrink: 0, height: `${window.innerHeight - 90}px`, minHeight: '400px' }}
      >
      </div>

      {/* Carousel Container */}
      <div 
        id="carousel-container" 
        className="flex flex-col justify-center lg:flex-[2] w-full lg:w-auto lg:border-l-4"
        style={{ height: `${window.innerHeight - 90}px`, minHeight: '400px'}}>
        <div
          className="custom-carousel h-1/2 border-b-4 border-solid border-white mx-auto w-full sm:w-[90%] md:w-[80%] lg:w-[500px]"
        >
          <CarouselComercial />
        </div>
        <div
          className="custom-carousel h-1/2 border-solid border-white mx-auto w-full sm:w-[90%] md:w-[80%] lg:w-[500px]"
        >
          <CarouselHome />
        </div>
      </div>
    </div>
      <div
        style={{ background: '#f7f7f7' }}
        className="py-16 px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 rounded-3xl rounded-b-md mt-10"
      >
        {/* Cards DIV */}
        <div className={`flex flex-wrap justify-left gap-52 transition-all duration-500 transform`}>
          <h3 className="text-2xl sm:text-xl md:text-3xl lg:text-4xl font-bold text-black text-left w-12/12 drop-shadow-md">
            Официјални партнери со Samsung
          </h3>
        </div>
        <Cards />
      </div>
      <div id="logo-clouds">
        <LogoClouds />
      </div>
      <div
        style={{ background: '#f7f7f7' }}
        className="py-16 px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 rounded-3xl rounded-t-md mt-10"
      >
        <div id="feed" className="flex flex-wrap justify-center mr-[20%]">
          <Feed />
        </div>
      </div>
    </div>
  );
}
